module.exports = __webpack_public_path__ + "static/media/Guided Surgery_1.166232c5.png";